import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IframeService } from 'src/app/shared/iframe/services/iframe.service';

@Component({
  selector: 'app-overlay-modal',
  templateUrl: './overlay-modal.component.html',
  styleUrls: ['./overlay-modal.component.scss']
})
export class OverlayModalComponent implements OnInit {
  private _url;
  get url() {
    return this._url;
  }
  @Input() title: string;
  @Input() set url(u: string) {
    this._url = u;
    this.publicUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this._url);
  }
  publicUrl: any;
  constructor(
    public activeModal: NgbActiveModal,
    private _sanitizer: DomSanitizer,
    private iframeService: IframeService
  ) { }

  ngOnInit() {
    setTimeout(() => {
      if (window.top.document) {
        this.iframeService.findAndRegisterFrames(window.top.document.body);
      }
      this.iframeService.findAndRegisterFramesForModalResize(window.document.body);
    });
  }

  close() {
    this.activeModal.dismiss();
  }

}
